import Comment from '@/models/Comment';
import ContractEvent from '@/models/ContractEvent';
import ContractEventService from '@/services/ContractEventService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useContractEventsStore = defineStore('contractEvents', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ContractEvent),
  },

  actions: {
    async fetchContractEvents(projectId: Id, params: ApiRequests['api.v1.contract-events.index'] = {}) {
      const [data, error] = await ContractEventService.index(projectId, params);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async fetchContractEvent(id: Id) {
      const [data, error] = await ContractEventService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async createContractEvent(projectId: Id, form: ApiRequests['api.v1.contract-events.store'] | FormData) {
      const [data, error] = await ContractEventService.create(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async updateContractEvent(id: Id, form: ApiRequests['api.v1.contract-events.update']) {
      const [data, error] = await ContractEventService.update(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async registerVariationOrder(contractEventId: Id) {
      const comments = useRepo(Comment);
      const [data, error] = await ContractEventService.registerVariationOrder(contractEventId);

      if(error) {
        throw error;
      }

      this.models.save(data.contract_event);

      comments.save(data.comment);

      return data;
    },

    async registerVariationOrderAndDelay(contractEventId: Id) {
      const comments = useRepo(Comment);
      const [data, error] = await ContractEventService.registerVariationOrderAndDelay(contractEventId);

      if(error) {
        throw error;
      }

      this.models.save(data.contract_event);

      comments.save(data.comment);

      return data;
    },

    async registerDelay(contractEventId: Id) {
      const comments = useRepo(Comment);
      const [data, error] = await ContractEventService.registerDelay(contractEventId);

      if(error) {
        throw error;
      }

      this.models.save(data.contract_event);

      comments.save(data.comment);

      return data;
    },

    async decline(contractEventId: Id) {
      const [data, error] = await ContractEventService.decline(contractEventId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async media(id: Id) {
      const [data, error] = await ContractEventService.media(id);

      if(error) {
        throw error;
      }

      return data;
    },

    async storeMedia(id: Id, form: ApiRequests['api.v1.contract-events.media.store'] | FormData) {
      const [data, error] = await ContractEventService.storeMedia(id, form);

      if(error) {
        throw error;
      }

      return data;
    },

    async updateNextActionContractEvent(id: Id, form: ApiRequests['api.v1.contract-events.next-action']) {
      const [data, error] = await ContractEventService.nextAction(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async saveNextActionSnapshot(id: Id) {
      const [comment, error] = await ContractEventService.saveNextAction(id);

      if(error) {
        throw error;
      }

      await this.fetchContractEvent(id);

      return comment;
    },

    async comment(id: Id, form: ApiRequests['api.v1.contract-events.comments']) {
      const [data, error] = await ContractEventService.comment(id, form);

      if(error) {
        throw error;
      }

      const comments = useRepo(Comment);

      comments.save(data);

      return data;
    },
  },
});
